import React, { FC, useEffect, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { ToastContainer } from 'react-toastify'
import { fetchData, getTranslatedValue, toasterrormsg } from '../../../reusable'
import { PageTitle } from '../../../_metronic/layout/core'
import { RestaurantDetailsHeader } from './RestaurantDetailsHeader'
import Fancybox from '../Fancybox'
import { toAbsoluteUrl } from '../../../_metronic/helpers'
import { Tr } from '../../../_metronic/i18n/Tr'
import { useLang } from '../../../_metronic/i18n/Metronici18n'

const RestaurantOverview: FC = () => {

    const t = Tr()
    const lang = useLang()
    const navigate = useNavigate();
    const categoryId = sessionStorage.getItem('categoryId');
    useEffect(() => {
        if (categoryId != '3') {
            navigate('../dashboard/');
        }
    }, [categoryId])
    var vendorId = "";
    const vendorData = sessionStorage.getItem("vendor");
    if (vendorData) {
        var vendor = JSON.parse(vendorData);
        vendorId = vendor.vendorId;

    } else {
        console.log("No vendor data found");
    }
    const location = useLocation();
    const restaurantId = (location.state as any)?.restaurantId || '';
    const [restaurantDetails, setRestaurantDetails] = useState([]);
    const [qqsList, setQqsList] = useState([])

    // restaurant Details api call
    const restaurantDetailsApiCall = async () => {
        var param: any = {
            vendorId: vendorId,
            'restaurantId': restaurantId
        }
        var response: any = await fetchData("public/restaurantDetail", param)

        if (response.status == "200") {
            var restaurantData = response.data
            setRestaurantDetails(restaurantData);
        }
        else {
            toasterrormsg(response.message)
        }
    }
    useEffect(() => {
        restaurantDetailsApiCall()
    }, [restaurantId])

    const opts = {
        fullScreen: {
            autoStart: true, // Auto-start in full-screen mode
        },
        Thumbs: false,
        // Other options...
    };

    const formatTime = (time: string) => {
        const [hours, minutes] = time.split(':').map(Number)
        const period = hours >= 12 ? 'PM' : 'AM'
        const adjustedHours = hours % 12 || 12
        const formattedMinutes = minutes < 10 ? `0${minutes}` : minutes // Ensure minutes are two digits
        return `${adjustedHours}:${formattedMinutes} ${period}`
    }

    const qqsListApiCall = async () => {
        var response: any = await fetchData('public/qqsList', {})
        if (response.status == '200') {
            const filterData = response.data.map((item: any) => ({ label: item.name, value: item.qqsId }))
            setQqsList(filterData)
        } else {
            toasterrormsg(response.message)
        }
    }
    useEffect(() => {
        qqsListApiCall()
    }, [])
    return (
        <>
            <PageTitle breadcrumbs={[]}>{t('Restaurant Overview')}</PageTitle>
            <ToastContainer />
            <RestaurantDetailsHeader />
            {restaurantDetails.map((restaurant: any, index: any) => {
                var selectedQqs: any =
                    qqsList.find((option: any) => option.value === restaurant['qqs']) || null

                const createdDate = new Date(restaurant['created'])

                // Add two years
                const createdDateTwoYearsLater = new Date(createdDate)
                createdDateTwoYearsLater.setFullYear(createdDate.getFullYear() + 2)

                // Check if dates are valid
                const isCreatedDateValid = !isNaN(createdDate.getTime())
                const isCreatedDateTwoYearsLaterValid = !isNaN(createdDateTwoYearsLater.getTime())

                // Parse availableDate into an array of objects
                const availableDates: any = restaurant['availableDate']
                // Filter and map start dates for 'unavailable' type
                const unavailableDates: any = availableDates
                    .filter((date: any) => date.type === 'unavailable')
                    .map((date: any) =>
                        new Date(date.start).toLocaleDateString('en-GB', {
                            day: '2-digit',
                            month: 'long',
                            year: 'numeric',
                        })
                    )
                return (
                    <div className='form' key={index}>
                        {/* <!--begin::Card--> */}
                        <div className='card'>
                            {/* <!--begin::Card header--> */}
                            <div className='card-header'>
                                {/* <!--begin::Card header--> */}
                                <div className='card-title fs-3 fw-bold'>{t('Basic Info')}</div>
                                {/* <!--end::Card header--> */}
                            </div>
                            {/* <!--end::Card header--> */}
                            {/* <!--begin::Card body--> */}
                            <div className='card-body'>
                                {restaurant['en_name'] && (
                                    <>
                                        {/* <!--begin::Row--> */}
                                        <div className='row mb-8'>
                                            {/* <!--begin::Col--> */}
                                            <div className='col-xl-3'>
                                                <div className='fs-6 fw-bold mt-2 mb-3'>{t('Property Name (English)')}</div>
                                            </div>
                                            {/* <!--end::Col--> */}

                                            {/* <!--begin::Col--> */}
                                            <div className='col-xl-9'>
                                                {/* <!--begin::Progress--> */}
                                                <div className='d-flex flex-column'>
                                                    <div className=' fw-semibold text-gray-600 mt-3'>
                                                        {restaurant['en_name']}
                                                    </div>
                                                </div>
                                                {/* <!--end::Progress--> */}
                                            </div>
                                            {/* <!--end::Col--> */}
                                        </div>
                                        {/* <!--end::Row--> */}
                                    </>
                                )}
                                {restaurant['ru_name'] && (
                                    <>
                                        {/* <!--begin::Row--> */}
                                        <div className='row mb-8'>
                                            {/* <!--begin::Col--> */}
                                            <div className='col-xl-3'>
                                                <div className='fs-6 fw-bold mt-2 mb-3'>{t('Property Name (Russian)')}</div>
                                            </div>
                                            {/* <!--end::Col--> */}

                                            {/* <!--begin::Col--> */}
                                            <div className='col-xl-9'>
                                                {/* <!--begin::Progress--> */}
                                                <div className='d-flex flex-column'>
                                                    <div className=' fw-semibold text-gray-600 mt-3'>
                                                        {restaurant['ru_name']}
                                                    </div>
                                                </div>
                                                {/* <!--end::Progress--> */}
                                            </div>
                                            {/* <!--end::Col--> */}
                                        </div>
                                        {/* <!--end::Row--> */}
                                    </>
                                )}
                                {restaurant['uz_name'] && (
                                    <>
                                        {/* <!--begin::Row--> */}
                                        <div className='row mb-8'>
                                            {/* <!--begin::Col--> */}
                                            <div className='col-xl-3'>
                                                <div className='fs-6 fw-bold mt-2 mb-3'>{t('Property Name (Uzbek)')}</div>
                                            </div>
                                            {/* <!--end::Col--> */}

                                            {/* <!--begin::Col--> */}
                                            <div className='col-xl-9'>
                                                {/* <!--begin::Progress--> */}
                                                <div className='d-flex flex-column'>
                                                    <div className=' fw-semibold text-gray-600 mt-3'>
                                                        {restaurant['uz_name']}
                                                    </div>
                                                </div>
                                                {/* <!--end::Progress--> */}
                                            </div>
                                            {/* <!--end::Col--> */}
                                        </div>
                                        {/* <!--end::Row--> */}
                                    </>
                                )}
                                {restaurant['type'] && (
                                    <>
                                        {/* <!--begin::Row--> */}
                                        <div className='row mb-8'>
                                            {/* <!--begin::Col--> */}
                                            <div className='col-xl-3'>
                                                <div className='fs-6 fw-bold mt-2 mb-3'>{t('Property Type')}</div>
                                            </div>
                                            {/* <!--end::Col--> */}

                                            {/* <!--begin::Col--> */}
                                            <div className='col-xl-9'>
                                                {/* <!--begin::Progress--> */}
                                                <div className='d-flex flex-column'>
                                                    <div className=' fw-semibold text-gray-600 mt-3'>
                                                        {restaurant['type'] == 'RESTAURANT' ? t('Restaurant') : t('Cafe')}
                                                    </div>
                                                </div>
                                                {/* <!--end::Progress--> */}
                                            </div>
                                            {/* <!--end::Col--> */}
                                        </div>
                                        {/* <!--end::Row--> */}
                                    </>
                                )}
                                {restaurant['email'] && (
                                    <>
                                        {/* <!--begin::Row--> */}
                                        <div className='row mb-8'>
                                            {/* <!--begin::Col--> */}
                                            <div className='col-xl-3'>
                                                <div className='fs-6 fw-bold mt-2 mb-3'>{t('Email')}</div>
                                            </div>
                                            {/* <!--end::Col--> */}

                                            {/* <!--begin::Col--> */}
                                            <div className='col-xl-9'>
                                                {/* <!--begin::Progress--> */}
                                                <div className='d-flex flex-column'>
                                                    <div className=' fw-semibold text-gray-600 mt-3'>
                                                        {restaurant['email']}
                                                    </div>
                                                </div>
                                                {/* <!--end::Progress--> */}
                                            </div>
                                            {/* <!--end::Col--> */}
                                        </div>
                                        {/* <!--end::Row--> */}
                                    </>
                                )}
                                {restaurant['phoneNo'] && (
                                    <>
                                        {/* <!--begin::Row--> */}
                                        <div className='row mb-8'>
                                            {/* <!--begin::Col--> */}
                                            <div className='col-xl-3'>
                                                <div className='fs-6 fw-bold mt-2 mb-3'>{t('Mobile Number')}</div>
                                            </div>
                                            {/* <!--end::Col--> */}

                                            {/* <!--begin::Col--> */}
                                            <div className='col-xl-9'>
                                                {/* <!--begin::Progress--> */}
                                                <div className='d-flex flex-column'>
                                                    <div className=' fw-semibold text-gray-600 mt-3'>
                                                        {restaurant['phoneNo']}
                                                    </div>
                                                </div>
                                                {/* <!--end::Progress--> */}
                                            </div>
                                            {/* <!--end::Col--> */}
                                        </div>
                                        {/* <!--end::Row--> */}
                                    </>
                                )}
                                {restaurant['contact_person_name'] && (
                                    <>
                                        {/* <!--begin::Row--> */}
                                        <div className='row mb-8'>
                                            {/* <!--begin::Col--> */}
                                            <div className='col-xl-3'>
                                                <div className='fs-6 fw-bold mt-2 mb-3'>{t('Contact Person Name')}</div>
                                            </div>
                                            {/* <!--end::Col--> */}

                                            {/* <!--begin::Col--> */}
                                            <div className='col-xl-9'>
                                                {/* <!--begin::Progress--> */}
                                                <div className='d-flex flex-column'>
                                                    <div className=' fw-semibold text-gray-600 mt-3'>
                                                        {restaurant['contact_person_name']}
                                                    </div>
                                                </div>
                                                {/* <!--end::Progress--> */}
                                            </div>
                                            {/* <!--end::Col--> */}
                                        </div>
                                        {/* <!--end::Row--> */}
                                    </>
                                )}

                                {restaurant['socialMediaChannels'] && restaurant['socialMediaChannels'].length > 0 && (
                                    <div className='row mb-8'>
                                        {/* <!--begin::Col--> */}
                                        <div className='col-xl-3'>
                                            <div className='fs-6 fw-bold mt-2 mb-3'>{t('Social Media Links')}</div>
                                        </div>
                                        {/* <!--end::Col--> */}

                                        {/* <!--begin::Col--> */}
                                        <div className='col-xl-9'>
                                            {/* <!--begin::Progress--> */}
                                            <div className='d-flex flex-column'>
                                                <div className='fw-semibold text-gray-600 mt-3'>
                                                    {/* Render each social media type and link on a new line */}
                                                    {restaurant['socialMediaChannels']
                                                        .filter(
                                                            (channel: any) =>
                                                                channel['socialMediaType'] && channel['socialMediaLink']
                                                        ) // Filter out channels without type or link
                                                        .map((channel: any, index: number) => (
                                                            <p key={index}>
                                                                <strong>{channel['socialMediaType']}:</strong>
                                                                {'  '}
                                                                <a
                                                                    href={channel['socialMediaLink']}
                                                                    target='_blank'
                                                                    rel='noopener noreferrer'
                                                                >
                                                                    {channel['socialMediaLink']}
                                                                </a>
                                                            </p>
                                                        ))}
                                                </div>
                                            </div>
                                            {/* <!--end::Progress--> */}
                                        </div>
                                        {/* <!--end::Col--> */}
                                    </div>
                                )}

                                <div className='col-xl-3 border-bottom border-light border-2 w-100 mb-5'>
                                    <div className='fs-3 fw-bold mb-5 '>{t('Property Location')}</div>
                                </div>

                                {restaurant['location'] && (
                                    <>
                                        {/* <!--begin::Row--> */}
                                        <div className='row mb-8'>
                                            {/* <!--begin::Col--> */}
                                            <div className='col-xl-3'>
                                                <div className='fs-6 fw-bold mt-2 mb-3'>{t('Location')}</div>
                                            </div>
                                            {/* <!--end::Col--> */}

                                            {/* <!--begin::Col--> */}
                                            <div className='col-xl-9'>
                                                {/* <!--begin::Progress--> */}
                                                <div className='d-flex flex-column'>
                                                    <div className=' fw-semibold text-gray-600 mt-3'>
                                                        {restaurant['location']}
                                                    </div>
                                                </div>
                                                {/* <!--end::Progress--> */}
                                            </div>
                                            {/* <!--end::Col--> */}
                                        </div>
                                        {/* <!--end::Row--> */}
                                    </>
                                )}

                                {restaurant['vendorDetails'] &&
                                    restaurant['vendorDetails'].map((vendordetail: any) => {
                                        return (
                                            <>
                                                {vendordetail['country'].map((country: any) => {
                                                    return (
                                                        <>
                                                            {country['name'] ? (
                                                                <>
                                                                    {/* <!--begin::Row--> */}
                                                                    <div className='row mb-8'>
                                                                        {/* <!--begin::Col--> */}
                                                                        <div className='col-xl-3'>
                                                                            <div className='fs-6 fw-bold mt-2 mb-3'>{t('Country')}</div>
                                                                        </div>
                                                                        {/* <!--end::Col--> */}

                                                                        {/* <!--begin::Col--> */}
                                                                        <div className='col-xl-9'>
                                                                            {/* <!--begin::Progress--> */}
                                                                            <div className='d-flex flex-column'>
                                                                                <div className=' fw-semibold text-gray-600 mt-3'>
                                                                                    <div>{country['name']}</div>
                                                                                </div>
                                                                            </div>
                                                                            {/* <!--end::Progress--> */}
                                                                        </div>
                                                                        {/* <!--end::Col--> */}
                                                                    </div>
                                                                    {/* <!--end::Row--> */}
                                                                </>
                                                            ) : (
                                                                ''
                                                            )}
                                                        </>
                                                    )
                                                })}

                                                {vendordetail['addressline1'] ? (
                                                    <>
                                                        {/* <!--begin::Row--> */}
                                                        <div className='row mb-8'>
                                                            {/* <!--begin::Col--> */}
                                                            <div className='col-xl-3'>
                                                                <div className='fs-6 fw-bold mt-2 mb-3'>{t('Address Line 1')}</div>
                                                            </div>
                                                            {/* <!--end::Col--> */}

                                                            {/* <!--begin::Col--> */}
                                                            <div className='col-xl-9'>
                                                                {/* <!--begin::Progress--> */}
                                                                <div className='d-flex flex-column'>
                                                                    <div className=' fw-semibold text-gray-600 mt-3'>
                                                                        <div>{vendordetail['addressline1']}</div>
                                                                    </div>
                                                                </div>
                                                                {/* <!--end::Progress--> */}
                                                            </div>
                                                            {/* <!--end::Col--> */}
                                                        </div>
                                                        {/* <!--end::Row--> */}
                                                    </>
                                                ) : (
                                                    ''
                                                )}

                                                {vendordetail['addressline2'] ? (
                                                    <>
                                                        {/* <!--begin::Row--> */}
                                                        <div className='row mb-8'>
                                                            {/* <!--begin::Col--> */}
                                                            <div className='col-xl-3'>
                                                                <div className='fs-6 fw-bold mt-2 mb-3'>{t('Address Line 2')}</div>
                                                            </div>
                                                            {/* <!--end::Col--> */}

                                                            {/* <!--begin::Col--> */}
                                                            <div className='col-xl-9'>
                                                                {/* <!--begin::Progress--> */}
                                                                <div className='d-flex flex-column'>
                                                                    <div className=' fw-semibold text-gray-600 mt-3'>
                                                                        <div>{vendordetail['addressline2']}</div>
                                                                    </div>
                                                                </div>
                                                                {/* <!--end::Progress--> */}
                                                            </div>
                                                            {/* <!--end::Col--> */}
                                                        </div>
                                                        {/* <!--end::Row--> */}
                                                    </>
                                                ) : (
                                                    ''
                                                )}
                                                {vendordetail['region'] ? (
                                                    <>
                                                        {/* <!--begin::Row--> */}
                                                        <div className='row mb-8'>
                                                            {/* <!--begin::Col--> */}
                                                            <div className='col-xl-3'>
                                                                <div className='fs-6 fw-bold mt-2 mb-3'>{t('Region')}</div>
                                                            </div>
                                                            {/* <!--end::Col--> */}

                                                            {/* <!--begin::Col--> */}
                                                            <div className='col-xl-9'>
                                                                {/* <!--begin::Progress--> */}
                                                                <div className='d-flex flex-column'>
                                                                    <div className=' fw-semibold text-gray-600 mt-3'>
                                                                        <div>{getTranslatedValue(lang, vendordetail['regionDetail'][0], '_name')}</div>
                                                                    </div>
                                                                </div>
                                                                {/* <!--end::Progress--> */}
                                                            </div>
                                                            {/* <!--end::Col--> */}
                                                        </div>
                                                        {/* <!--end::Row--> */}
                                                    </>
                                                ) : (
                                                    ''
                                                )}
                                                {vendordetail['zipcode'] ? (
                                                    <>
                                                        {/* <!--begin::Row--> */}
                                                        <div className='row mb-8'>
                                                            {/* <!--begin::Col--> */}
                                                            <div className='col-xl-3'>
                                                                <div className='fs-6 fw-bold mt-2 mb-3'>{t('Zip Code')}</div>
                                                            </div>
                                                            {/* <!--end::Col--> */}

                                                            {/* <!--begin::Col--> */}
                                                            <div className='col-xl-9'>
                                                                {/* <!--begin::Progress--> */}
                                                                <div className='d-flex flex-column'>
                                                                    <div className=' fw-semibold text-gray-600 mt-3'>
                                                                        <div>{vendordetail['zipcode']}</div>
                                                                    </div>
                                                                </div>
                                                                {/* <!--end::Progress--> */}
                                                            </div>
                                                            {/* <!--end::Col--> */}
                                                        </div>
                                                        {/* <!--end::Row--> */}
                                                    </>
                                                ) : (
                                                    ''
                                                )}
                                            </>
                                        )
                                    })}

                                {restaurant['en_aboutInformation'] != '' ? (
                                    <div className='col-xl-3 border-bottom border-light border-2 w-100 mb-5 mt-5'>
                                        <div className='fs-3 fw-bold mb-5 '>{t('Property Details')}</div>
                                    </div>
                                ) : (
                                    ''
                                )}

                                {restaurant['en_aboutInformation'] && (
                                    <>
                                        {/* <!--begin::Row--> */}
                                        <div className='row mb-8'>
                                            {/* <!--begin::Col--> */}
                                            <div className='col-xl-3'>
                                                <div className='fs-6 fw-bold mt-2 mb-3'>{t('About Information (English)')}</div>
                                            </div>
                                            {/* <!--end::Col--> */}

                                            {/* <!--begin::Col--> */}
                                            <div className='col-xl-9'>
                                                {/* <!--begin::Progress--> */}
                                                <div className='d-flex flex-column'>
                                                    <div className=' fw-semibold text-gray-600 mt-3'>
                                                        {restaurant['en_aboutInformation']}
                                                    </div>
                                                </div>
                                                {/* <!--end::Progress--> */}
                                            </div>
                                            {/* <!--end::Col--> */}
                                        </div>
                                        {/* <!--end::Row--> */}
                                    </>
                                )}
                                {restaurant['ru_aboutInformation'] && (
                                    <>
                                        {/* <!--begin::Row--> */}
                                        <div className='row mb-8'>
                                            {/* <!--begin::Col--> */}
                                            <div className='col-xl-3'>
                                                <div className='fs-6 fw-bold mt-2 mb-3'>{t('About Information (Russian)')}</div>
                                            </div>
                                            {/* <!--end::Col--> */}

                                            {/* <!--begin::Col--> */}
                                            <div className='col-xl-9'>
                                                {/* <!--begin::Progress--> */}
                                                <div className='d-flex flex-column'>
                                                    <div className=' fw-semibold text-gray-600 mt-3'>
                                                        {restaurant['ru_aboutInformation']}
                                                    </div>
                                                </div>
                                                {/* <!--end::Progress--> */}
                                            </div>
                                            {/* <!--end::Col--> */}
                                        </div>
                                        {/* <!--end::Row--> */}
                                    </>
                                )}
                                {restaurant['uz_aboutInformation'] && (
                                    <>
                                        {/* <!--begin::Row--> */}
                                        <div className='row mb-8'>
                                            {/* <!--begin::Col--> */}
                                            <div className='col-xl-3'>
                                                <div className='fs-6 fw-bold mt-2 mb-3'>{t('About Information (Uzbek)')}</div>
                                            </div>
                                            {/* <!--end::Col--> */}

                                            {/* <!--begin::Col--> */}
                                            <div className='col-xl-9'>
                                                {/* <!--begin::Progress--> */}
                                                <div className='d-flex flex-column'>
                                                    <div className=' fw-semibold text-gray-600 mt-3'>
                                                        {restaurant['uz_aboutInformation']}
                                                    </div>
                                                </div>
                                                {/* <!--end::Progress--> */}
                                            </div>
                                            {/* <!--end::Col--> */}
                                        </div>
                                        {/* <!--end::Row--> */}
                                    </>
                                )}

                                {restaurant['facilities'].length > 0 ? (
                                    <div className='col-xl-3 border-bottom border-light border-2 w-100 mb-5 mt-5'>
                                        <div className='fs-3 fw-bold mb-5 '>{t('Facilities & Services')}</div>
                                    </div>
                                ) : (
                                    ''
                                )}
                                {restaurant['facilities'] && restaurant['facilities'].length > 0 ? (
                                    <>
                                        {/* <!--begin::Row--> */}
                                        <div className='row mb-8'>
                                            {/* <!--begin::Col--> */}
                                            <div className='col-xl-3'>
                                                <div className='fs-6 fw-bold mt-2 mb-3'>{t('Facilities')}</div>
                                            </div>
                                            {/* <!--end::Col--> */}

                                            {/* <!--begin::Col--> */}
                                            <div className='col-xl-9'>
                                                {/* <!--begin::Progress--> */}
                                                <div className='d-flex'>
                                                    {restaurant['facilities'].map((facilities: any, index: any) => {
                                                        return (
                                                            <div key={index} className='fw-semibold text-gray-600 mt-0'>
                                                                {getTranslatedValue(lang, facilities, '_name')}
                                                                {index !== restaurant['facilities'].length - 1 ? ', ' : ''}
                                                            </div>
                                                        )
                                                    })}
                                                </div>
                                                {/* <!--end::Progress--> */}
                                            </div>
                                            {/* <!--end::Col--> */}
                                        </div>
                                        {/* <!--end::Row--> */}
                                    </>
                                ) : (
                                    ''
                                )}

                                {restaurant['ambience'] && restaurant['ambience'].length > 0 ? (
                                    <>
                                        {/* <!--begin::Row--> */}
                                        <div className='row mb-8'>
                                            {/* <!--begin::Col--> */}
                                            <div className='col-xl-3'>
                                                <div className='fs-6 fw-bold mt-2 mb-3'>{t('Ambience')}</div>
                                            </div>
                                            {/* <!--end::Col--> */}

                                            {/* <!--begin::Col--> */}
                                            <div className='col-xl-9'>
                                                {/* <!--begin::Progress--> */}
                                                <div className='d-flex'>
                                                    {restaurant['ambience'].map((facilities: any, index: any) => {
                                                        return (
                                                            <div key={index} className='fw-semibold text-gray-600 mt-0'>
                                                                {getTranslatedValue(lang, facilities, '_name')}
                                                                {index !== restaurant['ambience'].length - 1 ? ', ' : ''}
                                                            </div>
                                                        )
                                                    })}
                                                </div>
                                                {/* <!--end::Progress--> */}
                                            </div>
                                            {/* <!--end::Col--> */}
                                        </div>
                                        {/* <!--end::Row--> */}
                                    </>
                                ) : (
                                    ''
                                )}
                                {restaurant['cuisine'] && restaurant['cuisine'].length > 0 ? (
                                    <>
                                        {/* <!--begin::Row--> */}
                                        <div className='row mb-8'>
                                            {/* <!--begin::Col--> */}
                                            <div className='col-xl-3'>
                                                <div className='fs-6 fw-bold mt-2 mb-3'>{t('Cuisine Type')}</div>
                                            </div>
                                            {/* <!--end::Col--> */}

                                            {/* <!--begin::Col--> */}
                                            <div className='col-xl-9'>
                                                {/* <!--begin::Progress--> */}
                                                <div className='d-flex'>
                                                    {restaurant['cuisine'].map((facilities: any, index: any) => {
                                                        return (
                                                            <div key={index} className='fw-semibold text-gray-600 mt-0'>
                                                                {getTranslatedValue(lang, facilities, '_name')}
                                                                {index !== restaurant['cuisine'].length - 1 ? ', ' : ''}
                                                            </div>
                                                        )
                                                    })}
                                                </div>
                                                {/* <!--end::Progress--> */}
                                            </div>
                                            {/* <!--end::Col--> */}
                                        </div>
                                        {/* <!--end::Row--> */}
                                    </>
                                ) : (
                                    ''
                                )}

                                <div className='col-xl-3 border-bottom border-light border-2 w-100 mb-5 mt-5'>
                                    <div className='fs-3 fw-bold mb-5 '>{t('Availability')}</div>
                                </div>
                                {restaurant['availableDate'] ? (
                                    <>
                                        {/* <!--begin::Row--> */}
                                        <div className='row mb-8'>
                                            {/* <!--begin::Col--> */}
                                            <div className='col-xl-3'>
                                                <div className='fs-6 fw-bold mt-2 mb-3'>{t('Available Date')}</div>
                                            </div>
                                            {/* <!--end::Col--> */}

                                            {/* <!--begin::Col--> */}
                                            <div className='col-xl-9'>
                                                {/* <!--begin::Progress--> */}
                                                <div className='d-flex flex-column'>
                                                    <div className=' fw-semibold text-gray-600 mt-3'>
                                                        <div className='d-flex'>
                                                            <div>
                                                                {t('From:')}{' '}
                                                                {isCreatedDateValid
                                                                    ? createdDate.toLocaleDateString('en-GB', {
                                                                        day: '2-digit',
                                                                        month: 'long',
                                                                        year: 'numeric',
                                                                    })
                                                                    : t('Invalid date')}
                                                            </div>
                                                            <div className='date-separator'></div>
                                                            <div>
                                                                {t('To:')}{' '}
                                                                {isCreatedDateTwoYearsLaterValid
                                                                    ? createdDateTwoYearsLater.toLocaleDateString('en-GB', {
                                                                        day: '2-digit',
                                                                        month: 'long',
                                                                        year: 'numeric',
                                                                    })
                                                                    : t('Invalid date')}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                {/* <!--end::Progress--> */}
                                            </div>
                                            {/* <!--end::Col--> */}
                                        </div>
                                        {/* <!--end::Row--> */}
                                    </>
                                ) : (
                                    ''
                                )}
                                {unavailableDates.length > 0 ? (
                                    <>
                                        {/* <!--begin::Row--> */}
                                        <div className='row mb-8'>
                                            {/* <!--begin::Col--> */}
                                            <div className='col-xl-3'>
                                                <div className='fs-6 fw-bold mt-2 mb-3'>{t('Un Available Date')}</div>
                                            </div>
                                            {/* <!--end::Col--> */}

                                            {/* <!--begin::Col--> */}
                                            <div className='col-xl-9'>
                                                {/* <!--begin::Progress--> */}
                                                <div className='d-flex flex-column'>
                                                    <div className=' fw-semibold text-gray-600 mt-3'>
                                                        <div className='d-flex'>
                                                            {unavailableDates.length > 0 && <>{unavailableDates.join(', ')}</>}
                                                        </div>
                                                    </div>
                                                </div>
                                                {/* <!--end::Progress--> */}
                                            </div>
                                            {/* <!--end::Col--> */}
                                        </div>
                                        {/* <!--end::Row--> */}
                                    </>
                                ) : (
                                    ''
                                )}

                                {restaurant['en_additionalInformation'].length > 0 ? (
                                    <div className='col-xl-3 border-bottom border-light border-2 w-100 mb-5 mt-5'>
                                        <div className='fs-3 fw-bold mb-5 '>{t('Policies')}</div>
                                    </div>
                                ) : (
                                    ''
                                )}
                                {restaurant['en_additionalInformation'] && (
                                    <>
                                        {/* <!--begin::Row--> */}
                                        <div className='row mb-8'>
                                            {/* <!--begin::Col--> */}
                                            <div className='col-xl-3'>
                                                <div className='fs-6 fw-bold mt-2 mb-3'>
                                                    {t('Additional Information (English)')}
                                                </div>
                                            </div>
                                            {/* <!--end::Col--> */}

                                            {/* <!--begin::Col--> */}
                                            <div className='col-xl-9'>
                                                {/* <!--begin::Progress--> */}
                                                <div className='d-flex flex-column'>
                                                    <div className=' fw-semibold text-gray-600 mt-3'>
                                                        {restaurant['en_additionalInformation']}
                                                    </div>
                                                </div>
                                                {/* <!--end::Progress--> */}
                                            </div>
                                            {/* <!--end::Col--> */}
                                        </div>
                                        {/* <!--end::Row--> */}
                                    </>
                                )}
                                {restaurant['ru_additionalInformation'] && (
                                    <>
                                        {/* <!--begin::Row--> */}
                                        <div className='row mb-8'>
                                            {/* <!--begin::Col--> */}
                                            <div className='col-xl-3'>
                                                <div className='fs-6 fw-bold mt-2 mb-3'>
                                                    {t('Additional Information (Russian)')}
                                                </div>
                                            </div>
                                            {/* <!--end::Col--> */}

                                            {/* <!--begin::Col--> */}
                                            <div className='col-xl-9'>
                                                {/* <!--begin::Progress--> */}
                                                <div className='d-flex flex-column'>
                                                    <div className=' fw-semibold text-gray-600 mt-3'>
                                                        {restaurant['ru_additionalInformation']}
                                                    </div>
                                                </div>
                                                {/* <!--end::Progress--> */}
                                            </div>
                                            {/* <!--end::Col--> */}
                                        </div>
                                        {/* <!--end::Row--> */}
                                    </>
                                )}
                                {restaurant['uz_additionalInformation'] && (
                                    <>
                                        {/* <!--begin::Row--> */}
                                        <div className='row mb-8'>
                                            {/* <!--begin::Col--> */}
                                            <div className='col-xl-3'>
                                                <div className='fs-6 fw-bold mt-2 mb-3'>{t('Additional Information (Uzbek)')}</div>
                                            </div>
                                            {/* <!--end::Col--> */}

                                            {/* <!--begin::Col--> */}
                                            <div className='col-xl-9'>
                                                {/* <!--begin::Progress--> */}
                                                <div className='d-flex flex-column'>
                                                    <div className=' fw-semibold text-gray-600 mt-3'>
                                                        {restaurant['uz_additionalInformation']}
                                                    </div>
                                                </div>
                                                {/* <!--end::Progress--> */}
                                            </div>
                                            {/* <!--end::Col--> */}
                                        </div>
                                        {/* <!--end::Row--> */}
                                    </>
                                )}

                                {restaurant['openingHours'].length > 0 && (
                                    <>
                                        {/* <!--begin::Row--> */}
                                        <div className='row mb-8'>
                                            {/* <!--begin::Col--> */}
                                            <div className='col-xl-3'>
                                                <div className='fs-6 fw-bold mt-2 mb-3'>{t('Opening Hours')}</div>
                                            </div>
                                            {/* <!--end::Col--> */}

                                            {/* <!--begin::Col--> */}
                                            <div className='col-xl-9'>
                                                {/* <!--begin::Progress--> */}
                                                <div className='d-flex flex-column'>
                                                    {restaurant['openingHours'].map((dayInfo: any, index: any) => (
                                                        <div className='fw-semibold text-gray-600 mt-3' key={index}>
                                                            <div>
                                                                <strong>{t('Day:')}</strong> {dayInfo.day}
                                                            </div>
                                                            {dayInfo.timeSlot.map((slot: any, slotIndex: any) => (
                                                                <div key={slotIndex}>
                                                                    <strong>{t('Time Slot')} {slotIndex + 1}:</strong>{' '}
                                                                    {formatTime(slot.startTime)} - {formatTime(slot.endTime)}
                                                                </div>
                                                            ))}
                                                        </div>
                                                    ))}
                                                </div>
                                                {/* <!--end::Progress--> */}
                                            </div>
                                            {/* <!--end::Col--> */}
                                        </div>
                                        {/* <!--end::Row--> */}
                                    </>
                                )}

                                {restaurant['customPolicy'].length > 0 ? (
                                    <div className='col-xl-3 mb-5 mt-5'>
                                        <div className='fs-3 fw-bold mb-5 '>{t('Custom Policy')}</div>
                                    </div>
                                ) : (
                                    ''
                                )}
                                <div className='custom-docs-container'>
                                    {restaurant['customPolicy'] &&
                                        restaurant['customPolicy'].length > 0 &&
                                        restaurant['customPolicy'].map((item: any, index: any) => {
                                            return (
                                                <div key={index} className='custom-docs-item'>
                                                    {item.en_title && (
                                                        <div className='custom-docs-block'>
                                                            <div className='col-xl-3'>
                                                                <div className='fs-6 fw-bold mt-2 mb-3'>
                                                                    {t('Custom Policy English Title')}
                                                                </div>
                                                            </div>
                                                            <div className='col-xl-9'>
                                                                <div className='d-flex flex-column'>
                                                                    <div className='fw-semibold text-gray-600 mt-3'>
                                                                        <div
                                                                            dangerouslySetInnerHTML={{
                                                                                __html: item['en_title'],
                                                                            }}
                                                                        ></div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    )}
                                                    {item.en_description && (
                                                        <div className='custom-docs-block'>
                                                            <div className='col-xl-3'>
                                                                <div className='fs-6 fw-bold mt-2 mb-3'>
                                                                    {t('Custom Policy English Description')}
                                                                </div>
                                                            </div>
                                                            <div className='col-xl-9'>
                                                                <div className='d-flex flex-column'>
                                                                    <div className='fw-semibold text-gray-600 mt-3'>
                                                                        <div
                                                                            dangerouslySetInnerHTML={{
                                                                                __html: item['en_description'],
                                                                            }}
                                                                        ></div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    )}
                                                    {item.ru_title && (
                                                        <div className='custom-docs-block'>
                                                            <div className='col-xl-3'>
                                                                <div className='fs-6 fw-bold mt-2 mb-3'>
                                                                    {t('Custom Policy Russian Title')}
                                                                </div>
                                                            </div>
                                                            <div className='col-xl-9'>
                                                                <div className='d-flex flex-column'>
                                                                    <div className='fw-semibold text-gray-600 mt-3'>
                                                                        <div
                                                                            dangerouslySetInnerHTML={{
                                                                                __html: item['ru_title'],
                                                                            }}
                                                                        ></div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    )}
                                                    {item.ru_description && (
                                                        <div className='custom-docs-block'>
                                                            <div className='col-xl-3'>
                                                                <div className='fs-6 fw-bold mt-2 mb-3'>
                                                                    {t('Custom Policy Russian Description')}
                                                                </div>
                                                            </div>
                                                            <div className='col-xl-9'>
                                                                <div className='d-flex flex-column'>
                                                                    <div className='fw-semibold text-gray-600 mt-3'>
                                                                        <div
                                                                            dangerouslySetInnerHTML={{
                                                                                __html: item['ru_description'],
                                                                            }}
                                                                        ></div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    )}
                                                    {item.uz_title && (
                                                        <div className='custom-docs-block'>
                                                            <div className='col-xl-3'>
                                                                <div className='fs-6 fw-bold mt-2 mb-3'>
                                                                    {t('Custom Policy Uzbek Title')}
                                                                </div>
                                                            </div>
                                                            <div className='col-xl-9'>
                                                                <div className='d-flex flex-column'>
                                                                    <div className='fw-semibold text-gray-600 mt-3'>
                                                                        <div
                                                                            dangerouslySetInnerHTML={{
                                                                                __html: item['uz_title'],
                                                                            }}
                                                                        ></div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    )}
                                                    {item.uz_description && (
                                                        <div className='custom-docs-block'>
                                                            <div className='col-xl-3'>
                                                                <div className='fs-6 fw-bold mt-2 mb-3'>
                                                                    {t('Custom Policy Uzbek Description')}
                                                                </div>
                                                            </div>
                                                            <div className='col-xl-9'>
                                                                <div className='d-flex flex-column'>
                                                                    <div className='fw-semibold text-gray-600 mt-3'>
                                                                        <div
                                                                            dangerouslySetInnerHTML={{
                                                                                __html: item['uz_description'],
                                                                            }}
                                                                        ></div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    )}
                                                </div>
                                            )
                                        })}
                                </div>

                                {restaurant['ownerName'] != '' ? (
                                    <div className='col-xl-3 border-bottom border-light border-2 w-100 mb-5 mt-5'>
                                        <div className='fs-3 fw-bold mb-5 '>{t('Finance & Legal Information')}</div>
                                    </div>
                                ) : (
                                    ''
                                )}
                                {restaurant['ownerName'] && (
                                    <div className='row mb-8'>
                                        {/* <!--begin::Col--> */}
                                        <div className='col-xl-3'>
                                            <div className='fs-6 fw-bold mt-2 mb-3'>{t('Owner Name')}</div>
                                        </div>
                                        {/* <!--end::Col--> */}

                                        {/* <!--begin::Col--> */}
                                        <div className='col-xl-9'>
                                            {/* <!--begin::Progress--> */}
                                            <div className='d-flex flex-column'>
                                                <div className=' fw-semibold text-gray-600 mt-3'>
                                                    <div
                                                        dangerouslySetInnerHTML={{
                                                            __html: restaurant['ownerName'],
                                                        }}
                                                    ></div>
                                                </div>
                                            </div>
                                            {/* <!--end::Progress--> */}
                                        </div>
                                        {/* <!--end::Col--> */}
                                    </div>
                                )}
                                {restaurant['passportNumber'] && (
                                    <div className='row mb-8'>
                                        {/* <!--begin::Col--> */}
                                        <div className='col-xl-3'>
                                            <div className='fs-6 fw-bold mt-2 mb-3'>{t('ID/Passport Number')}</div>
                                        </div>
                                        {/* <!--end::Col--> */}

                                        {/* <!--begin::Col--> */}
                                        <div className='col-xl-9'>
                                            {/* <!--begin::Progress--> */}
                                            <div className='d-flex flex-column'>
                                                <div className=' fw-semibold text-gray-600 mt-3'>
                                                    <div
                                                        dangerouslySetInnerHTML={{
                                                            __html: restaurant['passportNumber'],
                                                        }}
                                                    ></div>
                                                </div>
                                            </div>
                                            {/* <!--end::Progress--> */}
                                        </div>
                                        {/* <!--end::Col--> */}
                                    </div>
                                )}
                                {restaurant['jShShIR'] && (
                                    <div className='row mb-8'>
                                        {/* <!--begin::Col--> */}
                                        <div className='col-xl-3'>
                                            <div className='fs-6 fw-bold mt-2 mb-3'>{t('JShShIR (ПИНФЛ)')}</div>
                                        </div>
                                        {/* <!--end::Col--> */}

                                        {/* <!--begin::Col--> */}
                                        <div className='col-xl-9'>
                                            {/* <!--begin::Progress--> */}
                                            <div className='d-flex flex-column'>
                                                <div className=' fw-semibold text-gray-600 mt-3'>
                                                    <div
                                                        dangerouslySetInnerHTML={{
                                                            __html: restaurant['jShShIR'],
                                                        }}
                                                    ></div>
                                                </div>
                                            </div>
                                            {/* <!--end::Progress--> */}
                                        </div>
                                        {/* <!--end::Col--> */}
                                    </div>
                                )}
                                {restaurant['businessName'] && (
                                    <div className='row mb-8'>
                                        {/* <!--begin::Col--> */}
                                        <div className='col-xl-3'>
                                            <div className='fs-6 fw-bold mt-2 mb-3'>{t('Business Name')}</div>
                                        </div>
                                        {/* <!--end::Col--> */}

                                        {/* <!--begin::Col--> */}
                                        <div className='col-xl-9'>
                                            {/* <!--begin::Progress--> */}
                                            <div className='d-flex flex-column'>
                                                <div className=' fw-semibold text-gray-600 mt-3'>
                                                    <div
                                                        dangerouslySetInnerHTML={{
                                                            __html: restaurant['businessName'],
                                                        }}
                                                    ></div>
                                                </div>
                                            </div>
                                            {/* <!--end::Progress--> */}
                                        </div>
                                        {/* <!--end::Col--> */}
                                    </div>
                                )}
                                {restaurant['businessSTIR'] && (
                                    <div className='row mb-8'>
                                        {/* <!--begin::Col--> */}
                                        <div className='col-xl-3'>
                                            <div className='fs-6 fw-bold mt-2 mb-3'>{t('Business STIR')}</div>
                                        </div>
                                        {/* <!--end::Col--> */}

                                        {/* <!--begin::Col--> */}
                                        <div className='col-xl-9'>
                                            {/* <!--begin::Progress--> */}
                                            <div className='d-flex flex-column'>
                                                <div className=' fw-semibold text-gray-600 mt-3'>
                                                    <div
                                                        dangerouslySetInnerHTML={{
                                                            __html: restaurant['businessSTIR'],
                                                        }}
                                                    ></div>
                                                </div>
                                            </div>
                                            {/* <!--end::Progress--> */}
                                        </div>
                                        {/* <!--end::Col--> */}
                                    </div>
                                )}
                                {restaurant['qqs'] && selectedQqs ? (
                                    <>
                                        {/* <!--begin::Row--> */}
                                        <div className='row mb-8'>
                                            {/* <!--begin::Col--> */}
                                            <div className='col-xl-3'>
                                                <div className='fs-6 fw-bold mt-2 mb-3'>{t('QQS')}</div>
                                            </div>
                                            {/* <!--end::Col--> */}

                                            {/* <!--begin::Col--> */}
                                            <div className='col-xl-9'>
                                                {/* <!--begin::Progress--> */}
                                                <div className='d-flex flex-column'>
                                                    <div className=' fw-semibold text-gray-600 mt-3'>
                                                        <div dangerouslySetInnerHTML={{ __html: selectedQqs.label }}></div>
                                                    </div>
                                                </div>
                                                {/* <!--end::Progress--> */}
                                            </div>
                                            {/* <!--end::Col--> */}
                                        </div>
                                        {/* <!--end::Row--> */}
                                    </>
                                ) : (
                                    ''
                                )}

                                {restaurant['mxikkodi'] ? (
                                    <>
                                        {/* <!--begin::Row--> */}
                                        <div className='row mb-8'>
                                            {/* <!--begin::Col--> */}
                                            <div className='col-xl-3'>
                                                <div className='fs-6 fw-bold mt-2 mb-3'>{t('MXIK kodi')}</div>
                                            </div>
                                            {/* <!--end::Col--> */}

                                            {/* <!--begin::Col--> */}
                                            <div className='col-xl-9'>
                                                {/* <!--begin::Progress--> */}
                                                <div className='d-flex flex-column'>
                                                    <div className=' fw-semibold text-gray-600 mt-3'>
                                                        <div dangerouslySetInnerHTML={{ __html: restaurant['mxikkodi'] }}></div>
                                                    </div>
                                                </div>
                                                {/* <!--end::Progress--> */}
                                            </div>
                                            {/* <!--end::Col--> */}
                                        </div>
                                        {/* <!--end::Row--> */}
                                    </>
                                ) : (
                                    ''
                                )}
                                {restaurant['oIchovBirligi'] ? (
                                    <>
                                        {/* <!--begin::Row--> */}
                                        <div className='row mb-8'>
                                            {/* <!--begin::Col--> */}
                                            <div className='col-xl-3'>
                                                <div className='fs-6 fw-bold mt-2 mb-3'>{t("O'Ichov Birligi")}</div>
                                            </div>
                                            {/* <!--end::Col--> */}

                                            {/* <!--begin::Col--> */}
                                            <div className='col-xl-9'>
                                                {/* <!--begin::Progress--> */}
                                                <div className='d-flex flex-column'>
                                                    <div className=' fw-semibold text-gray-600 mt-3'>
                                                        <div
                                                            dangerouslySetInnerHTML={{ __html: restaurant['oIchovBirligi'] }}
                                                        ></div>
                                                    </div>
                                                </div>
                                                {/* <!--end::Progress--> */}
                                            </div>
                                            {/* <!--end::Col--> */}
                                        </div>
                                        {/* <!--end::Row--> */}
                                    </>
                                ) : (
                                    ''
                                )}
                                <div className='row align-items-end h-100 gx-5 gx-xl-10'>
                                    {restaurant['businessDocument'] != '' ? (
                                        <Fancybox options={opts}>
                                            {/* <!--begin::Col--> */}
                                            <div className='col-md-4 mb-11 mb-md-0' key={index}>
                                                {/* <!--begin::Overlay--> */}
                                                <a
                                                    data-fancybox='gallery'
                                                    className='d-block overlay'
                                                    data-fslightbox='lightbox-hot-sales'
                                                    href={restaurant['businessDocument']}
                                                >
                                                    {/* <!--begin::Image--> */}
                                                    <div
                                                        className='overlay-wrapper bgi-position-center bgi-no-repeat bgi-size-cover h-200px card-rounded mb-3'
                                                        style={{
                                                            height: '266px',
                                                            backgroundImage: `url('${restaurant['businessDocument']}')`,
                                                        }}
                                                    ></div>
                                                    {/* <!--end::Image--> */}

                                                    {/* <!--begin::Action--> */}
                                                    <div className='overlay-layer card-rounded bg-dark bg-opacity-25'>
                                                        <i className='ki-outline ki-eye fs-3x text-white'></i>{' '}
                                                    </div>
                                                    {/* <!--end::Action-->       */}
                                                </a>
                                                {/* <!--end::Overlay-->          */}
                                            </div>
                                            {/* <!--end::Col-->      */}
                                        </Fancybox>
                                    ) : (
                                        ''
                                    )}

                                    {restaurant['idProofDocument'] != '' ? (
                                        <Fancybox options={opts}>
                                            {/* <!--begin::Col--> */}
                                            <div className='col-md-4 mb-11 mb-md-0' key={index}>
                                                {/* <!--begin::Overlay--> */}
                                                <a
                                                    data-fancybox='gallery'
                                                    className='d-block overlay'
                                                    data-fslightbox='lightbox-hot-sales'
                                                    href={restaurant['idProofDocument']}
                                                >
                                                    {/* <!--begin::Image--> */}
                                                    <div
                                                        className='overlay-wrapper bgi-position-center bgi-no-repeat bgi-size-cover h-200px card-rounded mb-3'
                                                        style={{
                                                            height: '266px',
                                                            backgroundImage: `url('${restaurant['idProofDocument']}')`,
                                                        }}
                                                    ></div>
                                                    {/* <!--end::Image--> */}
                                                    {/* <!--begin::Action--> */}
                                                    <div className='overlay-layer card-rounded bg-dark bg-opacity-25'>
                                                        <i className='ki-outline ki-eye fs-3x text-white'></i>{' '}
                                                    </div>
                                                    {/* <!--end::Action-->       */}
                                                </a>
                                                {/* <!--end::Overlay-->          */}
                                            </div>
                                            {/* <!--end::Col-->      */}
                                        </Fancybox>
                                    ) : (
                                        ''
                                    )}
                                </div>

                                <div className='col-xl-3 border-bottom border-light border-2 w-100 mb-5 mt-5'>
                                    <div className='fs-3 fw-bold mb-5'>{t('Menu Details')}</div>
                                </div>

                                {restaurant['restaurantmenu'] && restaurant['restaurantmenu'].length > 0 ? (
                                    <div className='col-xl-12'>
                                        {/* <!--begin::Engage widget 7--> */}
                                        <div className='card card-flush h-xl-100'>
                                            <div className='pt-7'>
                                                <div className='row align-items-end h-100 gx-5 gx-xl-10'>
                                                    {restaurant['restaurantmenu'].map((menu: any, index: any) => {
                                                        return (
                                                            <div className='col-md-4 mb-11 mb-md-0' key={index}>
                                                                <Fancybox options={opts}>
                                                                    {/* <!--begin::Overlay--> */}
                                                                    <a
                                                                        data-fancybox='gallery'
                                                                        className='d-block overlay'
                                                                        data-fslightbox='lightbox-hot-sales'
                                                                        href={menu['menuImage']}
                                                                    >
                                                                        <div
                                                                            className='overlay-wrapper bgi-position-center bgi-no-repeat bgi-size-cover h-200px card-rounded mb-3'
                                                                            style={{
                                                                                height: '266px',
                                                                                backgroundImage: `url('${menu['menuImage']}')`,
                                                                            }}
                                                                        ></div>
                                                                        {/* <!--end::Image--> */}

                                                                        {/* <!--begin::Action--> */}
                                                                        <div className='overlay-layer card-rounded bg-dark bg-opacity-25'>
                                                                            <i className='ki-outline ki-eye fs-3x text-white'></i>
                                                                        </div>
                                                                        {/* <!--end::Action-->       */}
                                                                    </a>
                                                                    {/* <!--end::Overlay--> */}
                                                                </Fancybox>

                                                                {/* Menu Name */}
                                                                <div className='text-center mt-2'>
                                                                    <div className='fw-bold fs-5'>
                                                                        {getTranslatedValue(lang, menu, '_menuName')}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        )
                                                    })}
                                                </div>
                                                {/* <!--end::Row--> */}
                                            </div>
                                            {/* <!--end::Card body--> */}
                                        </div>
                                        {/* <!--end::Engage widget 7--> */}
                                    </div>
                                ) : (
                                    <div className='col-xl-12'>
                                        {/* <!--begin::Engage widget 1--> */}
                                        <div className='card h-md-100' dir='ltr'>
                                            {/* <!--begin::Body--> */}
                                            <div className='card-body d-flex flex-column flex-center'>
                                                {/* <!--begin::Heading--> */}
                                                <div className='mb-2'>
                                                    {/* <!--begin::Illustration--> */}
                                                    <div className='py-10 text-center'>
                                                        <img
                                                            src={toAbsoluteUrl('/media/svg/illustrations/easy/2.svg')}
                                                            className='theme-light-show h-125px'
                                                            alt=''
                                                        />
                                                        <img
                                                            src={toAbsoluteUrl('/media/svg/illustrations/easy/2-dark.svg')}
                                                            className='theme-dark-show h-125px'
                                                            alt=''
                                                        />
                                                    </div>
                                                    {/* <!--end::Illustration--> */}
                                                </div>
                                                {/* <!--end::Heading--> */}
                                            </div>
                                            {/* <!--end::Body--> */}
                                        </div>
                                        {/* <!--end::Engage widget 1--> */}
                                    </div>
                                )}

                                <div className='col-xl-3 border-bottom border-light border-2 w-100 mb-5 mt-5'>
                                    <div className='fs-3 fw-bold mb-5 '>{t('Restaurant Photos')}</div>
                                </div>

                                {restaurant['images'] && restaurant['images'].length > 0 ? (
                                    <div className='col-xl-12'>
                                        {/* <!--begin::Engage widget 7--> */}
                                        <div className='card card-flush h-xl-100'>
                                            <div className='pt-7'>
                                                <div className='row align-items-end h-100 gx-5 gx-xl-10'>
                                                    {restaurant['images'].map((menu: any, index: any) => {
                                                        return (
                                                            <div className='col-md-4 mb-11 mb-md-0' key={index}>
                                                                <Fancybox options={opts}>
                                                                    {/* <!--begin::Overlay--> */}
                                                                    <a
                                                                        data-fancybox='gallery'
                                                                        className='d-block overlay'
                                                                        data-fslightbox='lightbox-hot-sales'
                                                                        href={menu['mediaPath']}
                                                                    >
                                                                        <div
                                                                            className='overlay-wrapper bgi-position-center bgi-no-repeat bgi-size-cover h-200px card-rounded mb-3'
                                                                            style={{
                                                                                height: '266px',
                                                                                backgroundImage: `url('${menu['mediaPath']}')`,
                                                                            }}
                                                                        ></div>
                                                                        {/* <!--end::Image--> */}

                                                                        {/* <!--begin::Action--> */}
                                                                        <div className='overlay-layer card-rounded bg-dark bg-opacity-25'>
                                                                            <i className='ki-outline ki-eye fs-3x text-white'></i>
                                                                        </div>
                                                                        {/* <!--end::Action-->       */}
                                                                    </a>
                                                                    {/* <!--end::Overlay--> */}
                                                                </Fancybox>

                                                                {/* Menu Name */}
                                                                <div className='text-center mt-2'>
                                                                    <h6>
                                                                        {getTranslatedValue(lang, menu, '_menuName')}
                                                                    </h6>
                                                                </div>
                                                            </div>
                                                        )
                                                    })}
                                                </div>
                                                {/* <!--end::Row--> */}
                                            </div>
                                            {/* <!--end::Card body--> */}
                                        </div>
                                        {/* <!--end::Engage widget 7--> */}
                                    </div>
                                ) : (
                                    <div className='col-xl-12'>
                                        {/* <!--begin::Engage widget 1--> */}
                                        <div className='card h-md-100' dir='ltr'>
                                            {/* <!--begin::Body--> */}
                                            <div className='card-body d-flex flex-column flex-center'>
                                                {/* <!--begin::Heading--> */}
                                                <div className='mb-2'>
                                                    {/* <!--begin::Illustration--> */}
                                                    <div className='py-10 text-center'>
                                                        <img
                                                            src={toAbsoluteUrl('/media/svg/illustrations/easy/2.svg')}
                                                            className='theme-light-show h-125px'
                                                            alt=''
                                                        />
                                                        <img
                                                            src={toAbsoluteUrl('/media/svg/illustrations/easy/2-dark.svg')}
                                                            className='theme-dark-show h-125px'
                                                            alt=''
                                                        />
                                                    </div>
                                                    {/* <!--end::Illustration--> */}
                                                </div>
                                                {/* <!--end::Heading--> */}
                                            </div>
                                            {/* <!--end::Body--> */}
                                        </div>
                                        {/* <!--end::Engage widget 1--> */}
                                    </div>
                                )}
                            </div>
                        </div>
                        {/* <!--end::Card--> */}
                    </div>
                )
            })}
        </>
    )
}

export { RestaurantOverview }